import { CABINET_CDN_PATH } from '../../cabinet-constants';

export const CABINET_PARTICULARITY_LIST = [
  {
    title: 'Более\n10 000 оттенков',
    elementText: 'Более 10 000 оттенков',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/palette-ld.png/palette-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/palette.png/palette.png`,
      alt: '',
    },
    description: 'Мы\u00A0предлагаем большой выбор стилей и\u00A0цветов и\u00A0обязательно учтём все особенности интерьера, чтобы вы\u00A0получили именно тот шкаф, о\u00A0котором мечтали.',
  },
  {
    title: 'Большой\nвыбор материалов',
    elementText: 'Большой выбор материалов',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/variety-ld.png/variety-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/variety.png/variety.png`,
      alt: '',
    },
    description: 'Мы\u00A0создаём шкафы из\u00A0шпона, МДФ, ЛДСП и\u00A0других современных материалов. А\u00A0также регулярно пополняем коллекции актуальными цветами и\u00A0текстурами.',
  },
  {
    title: 'Бесплатный онлайн-проект\nс дизайнером',
    elementText: 'Бесплатный онлайн-проект с дизайнером',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/online-project-ld.png/online-project-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/online-project.png/online-project.png`,
      alt: '',
    },
    description: 'Хотите обновить интерьер, не\u00A0выходя из\u00A0дома? Наш дизайнер создаст для вас уникальный проект в\u00A0онлайне: подберёт стиль, цветовую палитру, учтёт все размеры и\u00A0ваши предпочтения.',
  },
  {
    title: 'Персональный\nменеджер ',
    elementText: 'Персональный менеджер ',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/messenger-ld.png/messenger-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/messenger.png/messenger.png`,
      alt: '',
    },
    description: 'Наш менеджер будет рядом на\u00A0каждом этапе\u00A0\u2014 поможет с\u00A0дизайном и\u00A0выбором материалов, а\u00A0также проконтролирует сроки и\u00A0качество выполнения работ.',
  },
  {
    title: 'Профессиональная\nсборка',
    elementText: 'Профессиональная сборка',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/professional-ld.png/professional-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/professional.png/professional.png`,
      alt: '',
    },
    description: 'От\u00A0правильной сборки зависит удобство и\u00A0долговечность изделия\u00A0\u2014 наши мастера соберут всё быстро и\u00A0качественно, чтобы результат радовал вас долгие годы.',
  },
  {
    title: 'Надежность\nи качество',
    elementText: 'Надежность и качество',
    image: {
      srcLd: `${CABINET_CDN_PATH}/peculiarities/quality-ld.png/quality-ld.png`,
      src: `${CABINET_CDN_PATH}/peculiarities/quality.png/quality.png`,
      alt: '',
    },
    description: 'Мы\u00A0работаем только с\u00A0проверенными производителями, предлагая надёжные, стильные и\u00A0функциональные шкафы, созданные по\u00A0европейским стандартам.',
  },
];
